import React, { useContext } from 'react';

import { apiClient } from '../services/api';

const context = React.createContext(apiClient);
const { Consumer: ApiConsumer, Provider: ApiProvider } = context;

/** @type {() => typeof apiClient} */
const useApiClient = () => useContext(context);

export { ApiConsumer, ApiProvider, useApiClient };
